import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { SpeechRecognitionService } from '../../services/speech2.service';

@Component({
  selector: 'app-speech-button',
  templateUrl: './speech-button.component.html',
  styleUrls: ['./speech-button.component.scss']
})
export class SpeechButtonComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Output() textRecognized: EventEmitter<string> = new EventEmitter<string>();
  @Output() statusChanged: EventEmitter<string> = new EventEmitter<string>();

  listening: boolean = false;
  transcript: string = '';
  speechSubscription: any;

  constructor(private speechRecognitionService: SpeechRecognitionService) { }

  ngOnInit(): void {
    
  }

  onStartStop() {
    if (this.disabled) return;

    if (!this.listening) {
      this.transcript = '';
      this.speechSubscription = this.speechRecognitionService.speechRecognitionResult.subscribe(result => {
        if (result && result.result) {
          this.transcript += result.result + ' ';
          this.textRecognized.emit(result.result.trim());
          // Emitir 'stopped' inmediatamente al recibir texto
          this.statusChanged.emit('stopped');
          this.stopRecognition(true);
        }
      });

      this.speechRecognitionService.initRecognition();
      this.speechRecognitionService.startContinuousRecognition();
      this.listening = true;
      this.statusChanged.emit('started');
    } else {
      this.stopRecognition();
    }
  }

  private stopRecognition(immediate = false) {
    if (this.listening) {
      this.speechRecognitionService.stopRecognition();
      this.listening = false;
      if (immediate) {
        if (this.speechSubscription) {
          this.speechSubscription.unsubscribe();
        }
      } else {
        setTimeout(() => {
          this.statusChanged.emit('stopped');
          if (this.speechSubscription) {
            this.speechSubscription.unsubscribe();
          }
        }, 500); // margen pequeño para UX
      }
    }
  }
}
